import { Icon, type IconName } from './Icon.tsx';

export const PAGES = ['home', 'tasks', 'week', 'lessons', 'class', 'follow', 'more', 'account'] as const;
export type PageId = (typeof PAGES)[number];

const NAV: readonly { id: Exclude<PageId, 'tasks'>; icon: IconName; label: string }[] = [
  { id: 'home', icon: 'home', label: 'Accueil' },
  { id: 'week', icon: 'cal', label: 'Agenda' },
  { id: 'lessons', icon: 'book', label: 'Leçons' },
  { id: 'class', icon: 'users', label: 'Élèves' },
  { id: 'follow', icon: 'target', label: 'Suivi' },
  { id: 'more', icon: 'more', label: 'Plus' },
  { id: 'account', icon: 'user', label: 'Compte' },
];

export function Nav({
  current,
  onNavigate,
}: {
  current: PageId;
  onNavigate: (page: PageId) => void;
}) {
  return (
    <nav class="nav">
      {NAV.map(({ id, icon, label }) => (
        <button
          key={id}
          class={id === current ? 'active' : undefined}
          aria-current={id === current ? 'page' : undefined}
          onClick={() => onNavigate(id)}
        >
          <Icon name={icon} size={22} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
